import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import GiftIcon from '../../assets/images/icons/gift_white.png';
import CardImage from '../../assets/images/pages/homepage/homepage_starcard.png';
import HomepageLayout from '../../components/layouts/HomepageLayout';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Homepage | Caltex StarCard</title>
      </Helmet>

      <HomepageLayout>
        <Typography
          sx={{
            fontSize: '2.5rem',
            lineHeight: '2rem',
            fontWeight: '500',
            color: '#005972',
            textAlign: 'center',
          }}
        >
          ยินดีต้อนรับสู่​
        </Typography>
        <Typography
          sx={{
            fontSize: '3.75rem',
            fontWeight: '600',
            color: '#005972',
            textAlign: 'center',
            lineHeight: '3rem',
          }}
        >
          สตาร์การ์ด คลับ
        </Typography>
        <Typography
          sx={{
            fontSize: '6.5rem',
            fontWeight: '600',
            color: '#005972',
            textAlign: 'center',
            lineHeight: '4.5rem',
          }}
        >
          2026
        </Typography>
        <Box
          component={'img'}
          src={CardImage}
          alt="Caltex Starcard Club"
          sx={{
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto',
            transform: 'scale(120%) translateY(-20px)',
            display: 'block',
          }}
        />
        <Typography
          sx={{
            fontSize: '2.2rem',
            textAlign: 'center',
            fontWeight: '700',
            lineHeight: '1.8rem',
            marginTop: '-20px',
            marginBottom: '20px',
            color: '#005972',
          }}
        >
          SMART CONTROL,
          <br /> TRUSTED FUEL.
        </Typography>
        <Typography
          sx={{
            fontSize: '1.75rem',
            lineHeight: '1.5rem',
            textAlign: 'center',
            color: '#005972',
            fontWeight: '500',
          }}
        >
          ทุกลิตรมีคะแนน สะสมง่าย แลกได้ทันที
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#E1000C',
            padding: '8px 25px',
            gap: '10px',
            width: 'fit-content',
            margin: '10px auto 20px',
            borderRadius: '8px',
          }}
        >
          <Typography
            sx={{ color: 'white', fontSize: '2.2rem', lineHeight: '2rem', fontWeight: '500' }}
          >
            1,000 ลิตร = 1 คะแนน
          </Typography>
          <Box
            component={'img'}
            src={GiftIcon}
            alt="Gift Icon"
            sx={{ width: '35px', marginTop: '-5px' }}
          />
        </Box>
        <Typography
          sx={{ fontSize: '1.25rem', lineHeight: '1.2rem', color: '#005972', textAlign: 'center' }}
        >
          ตั้งแต่ 1 มกราคม 2569 - 30 พฤศจิกายน 2569
          <br />
          หมดเขตแลกของรางวัล 10 ธันวาคม 2569
        </Typography>
      </HomepageLayout>
    </>
  );
};

export default HomePage;
